export enum FeatureFlag {
	AccessAudit = 'AccessAudit',
	AccessComparison = 'AccessComparison',
	AccessExplainer = 'AccessExplainer',
	AIWorkflowApexClass = 'AiWorkflowApexClass',
	AIWorkflowInitiativeGenerator = 'AiWorkflowInitiativeGenerator',
	AIWorkflowReleaseNotesGenerator = 'AiWorkflowReleaseNotesGenerator',
	AIWorkflowSetupAuditTrailChangesSummary = 'AiWorkflowSetupAuditTrailChangesSummary',
	AIWorkflowValidationRule = 'AiWorkflowValidationRule',
	Autodoc = 'Autodoc',
	AutomaticallyRevokeNewOAuthAccessTokens = 'AutomaticallyRevokeNewOAuthAccessTokens',
	DataDictionary = 'DataDictionaryEnabled',
	DataSecurityApplicationStatus = 'PulseApplicationStatus',
	DataSecurityDashboard = 'PulseDashboard',
	DataSecurityGraphTools = 'PulseGraphTools',
	EmbeddedDataDictionary = 'EmbeddedDataDictionary',
	Export = 'Export',
	Followers = 'Followers',
	JiraIntegration = 'JiraIntegration',
	OpenApiKeyManagement = 'OpenApiKeyManagement',
	PardotAccountFieldSync = 'PardotAccountFieldSync',
	PardotAutomationRuleSync = 'PardotAutomationRuleSync',
	PardotDraftEmailSync = 'PardotDraftEmailSync',
	PardotEmailTemplateSync = 'PardotEmailTemplateSync',
	PardotEnabled = 'PardotEnabled',
	PardotFormSync = 'PardotFormSync',
	PardotImportVerboseLogging = 'PardotImportVerboseLogging',
	PardotLandingPageSync = 'PardotLandingPageSync',
	PardotListSync = 'PardotListSync',
	PardotOpportunityFieldSync = 'PardotOpportunityFieldSync',
	PardotPageActionSync = 'PardotPageActionSync',
	PardotProfileSync = 'PardotProfileSync',
	PardotProspectFieldSync = 'PardotProspectFieldSync',
	PardotScheduledEmailSync = 'PardotScheduledEmailSync',
	PardotSentEmailSync = 'PardotSentEmailSync',
	RecommendedActionTemplates = 'RecommendedActionTemplates',
	SalesforceEmailTemplateSync = 'SfEmailTemplateSync',
	SalesforceFlowSync = 'SfFlowSync',
	SalesforceImportBuffering = 'SfdcImportBuffering',
	SalesforceImportTolerant = 'TolerantSfImport',
	SalesforcePageLayoutSync = 'SfPageLayoutSync',
	SalesforceProfileSync = 'SfProfileSync',
	SalesforceReportSync = 'SfReportSync',
	SetupAuditTrail = 'SetupAuditTrail',
	UseNewProfileFieldPermissionData = 'UseNewProfileFieldPermissionData',
	UsePrivateSubnetsForTasks = 'UsePrivateSubnetsForTasks',
}

export type FeatureFlagDictionary = {
	[key in Uncapitalize<FeatureFlag>]: boolean;
};

export const FeatureFlagLabel: Record<Uncapitalize<FeatureFlag>, string> = {
	accessAudit: 'Access Audit',
	accessComparison: 'Access Comparison',
	accessExplainer: 'Access Explainer',
	aiWorkflowApexClass: 'AI Workflow for Apex Classes',
	aiWorkflowInitiativeGenerator: 'AI Workflow for Initiatives',
	aiWorkflowReleaseNotesGenerator: 'AI Workflow for Release Notes',
	aiWorkflowSetupAuditTrailChangesSummary: 'AI Workflow for Setup Audit Trail',
	aiWorkflowValidationRule: 'AI Workflow for Validation Rules',
	autodoc: 'Autodoc',
	automaticallyRevokeNewOAuthAccessTokens: 'Automatically Revoke New OAuth Access Tokens',
	dataDictionaryEnabled: 'Data Dictionary',
	embeddedDataDictionary: 'Data Dictionary Embedded Views',
	export: 'Export',
	followers: 'Followers',
	jiraIntegration: 'Jira Integration',
	openApiKeyManagement: 'Open Api Key Management',
	pardotAccountFieldSync: 'Syncing Pardot Account Fields',
	pardotAutomationRuleSync: 'Syncing Pardot Automation Rules',
	pardotDraftEmailSync: 'Syncing Pardot Draft Emails',
	pardotEmailTemplateSync: 'Syncing Pardot Email Templates',
	pardotEnabled: 'Pardot Integration',
	pardotFormSync: 'Syncing Pardot Forms',
	pardotImportVerboseLogging: 'Verbose Logging for Pardot Imports',
	pardotLandingPageSync: 'Syncing Pardot Landing Pages',
	pardotListSync: 'Syncing Pardot Lists',
	pardotOpportunityFieldSync: 'Syncing Pardot Opportunity Fields',
	pardotPageActionSync: 'Syncing Pardot Page Actions',
	pardotProfileSync: 'Syncing Pardot Profiles',
	pardotProspectFieldSync: 'Syncing Pardot Prospect Fields',
	pardotScheduledEmailSync: 'Syncing Pardot Scheduled Emails',
	pardotSentEmailSync: 'Syncing Pardot Sent Emails',
	pulseApplicationStatus: 'Data Security Application Status',
	pulseDashboard: 'Event Monitoring',
	pulseGraphTools: 'Data Security Graph Tools',
	recommendedActionTemplates: 'Recommended Action Templates',
	setupAuditTrail: 'Setup Audit Trail',
	sfEmailTemplateSync: 'Salesforce Email Templates',
	sfFlowSync: 'Salesforce Flows',
	sfPageLayoutSync: 'Salesforce Page Layouts',
	sfProfileSync: 'Salesforce Profiles',
	sfReportSync: 'Salesforce Reports',
	sfdcImportBuffering: 'Buffer Salesforce API calls to S3',
	tolerantSfImport: 'Tolerate Errors in Salesforce Import',
	useNewProfileFieldPermissionData: 'Use New Profile Field Permission Data',
	usePrivateSubnetsForTasks: 'Use Private Subnets for Tasks'
};
